/** User-facing name for the 0–100 reflection load metric (pattern intensity, not a mood or wellness score). */
export const MENTAL_LOAD_INDEX_TITLE = "Mental load index";

/** App route for the mental load index detail page. */
export const MENTAL_LOAD_INDEX_ROUTE = "/behavioral-patterns/mental-load";

export function getWellnessLabel(score) {
  if (score >= 75) return "Low mental load";
  if (score >= 60) return "Stable load";
  if (score >= 45) return "Mixed load";
  if (score >= 30) return "Elevated load";
  return "High mental load detected";
}

/** Procedural helper when load index is elevated. */
export function getWellnessHelper(score) {
  if (score == null) return null;
  if (score < 30) return "Prioritize reducing rumination frequency";
  if (score < 45) return "Defer non-urgent responses";
  return null;
}

/** Atlas specifics in Happy / Strong / Calm / Surprised (positive contribution). */
export const POSITIVE_EMOTIONS = new Set([
  "Joyful",
  "Hopeful",
  "Proud",
  "Loved",
  "Peaceful",
  "Curious",
  "Energetic",
  "Aroused",
  "Valued",
  "Optimistic",
  "Playful",
  "Content",
  "Accepted",
  "Interested",
  "Strong",
  "Empowered",
  "Faithful",
  "Appreciated",
  "Courageous",
  "Confident",
  "Successful",
  "Creative",
  "Respected",
  "Loyal",
  "Focused",
  "Calm",
  "Connected",
  "Trusting",
  "Thankful",
  "Secure",
  "Thoughtful",
  "Relieved",
  "Belonging",
  "Sensitive",
  "Loving",
  "Serene",
  "Relaxed",
  "Safe",
  "Surprised",
  "Amazed",
  "Excited"
]);

/** Atlas specifics in Sad / Angry / Fearful / Disgusted (+ crisis). */
export const CHALLENGING_EMOTIONS = new Set([
  "Confused",
  "Embarrassed",
  "Indifferent",
  "Depressed",
  "Remorseful",
  "Guilty",
  "Fragile",
  "Isolated",
  "Miserable",
  "Bored",
  "Ashamed",
  "Sad",
  "Lonely",
  "Disappointed",
  "Hurt",
  "Vulnerable",
  "Annoyed",
  "Stressed",
  "Rage",
  "Hostile",
  "Selfish",
  "Furious",
  "Irritated",
  "Skeptical",
  "Distrustful",
  "Angry",
  "Frustrated",
  "Critical",
  "Jealous",
  "Fearful",
  "Anxious",
  "Overwhelmed",
  "Insecure",
  "Disgusted",
  "Disapproving",
  "Needs Support"
]);
